import { render, staticRenderFns } from "./SimpleRichEditor.vue?vue&type=template&id=591da1c0&scoped=true"
import script from "./SimpleRichEditor.vue?vue&type=script&lang=js"
export * from "./SimpleRichEditor.vue?vue&type=script&lang=js"
import style0 from "./SimpleRichEditor.vue?vue&type=style&index=0&id=591da1c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591da1c0",
  null
  
)

export default component.exports